// by default all Object3Ds are a member of layer 0
export enum ViewerLayer {
  Default = 0,
  AutoPickable,
  SphericalViewerLayer,
  EDLShaderLayer,
}
